import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Form from "rc-field-form";
import moment from "moment-timezone";
import DateInput from "../../../components/Inputs/DateInput";
import ResourceSelect from "../../../components/Inputs/ResourceSelect";
import { getSettingsResourceSearchFilters, renderSettingsResourceLabel } from "../../../utils/helpers/settings";
import Field from "../../../components/Field";
import Button from "../../../components/Button";

function PBJForm({ mode, values, close, post, edit, loading }) {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const isEdit = mode === "edit";

    const onFinish = useCallback(
        (data) => {
            const formattedData = {
                startEffectiveDate: moment(data.startEffectiveDate).format("YYYY-MM-DD"),
                endEffectiveDate: data.endEffectiveDate
                    ? moment(data.endEffectiveDate).format("YYYY-MM-DD")
                    : null,
                pbjCode: data.pbjCode?.id,
                description: data.pbjCode?.description,
                status: "active",
            };
            if (isEdit && values?.id) {
                edit(values.id, formattedData, close);
            } else {
                post(formattedData, close);
            }
        },
        [isEdit, values?.id, edit, post, close]
    );

    useEffect(() => {
        form.resetFields();
        if (isEdit && values) {
            console.log(values);
            form.setFieldsValue({
                startEffectiveDate: values.startEffectiveDate ? moment(values.startEffectiveDate).toDate() : undefined,
                endEffectiveDate: values.endEffectiveDate ? moment(values.endEffectiveDate).toDate() : undefined,
                pbjCode: values.pbjCode,
            });
        } else {
            form.setFieldsValue({
                startDate: undefined,
                endDate: undefined,
                pbjCode: undefined,
            });
        }
    }, [form, isEdit, values]);

    return (
        <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            scrollToFirstError
        >
            <Field
                name="startEffectiveDate"
                label={t("start-effective-date")}
                rules={[
                    {
                        required: true,
                        message: t("required-start-effective-date"),
                    },
                ]}
            >
                <DateInput placeholder={t("start-effective-date")} dateFormat="yyyy-MM-dd" />
            </Field>

            <Field
                name="endEffectiveDate"
                label={t("end-effective-date")}
                dependencies={["startEffectiveDate"]}
                rules={[
                    ({ getFieldValue }) => ({
                        validator: (_, value) => {
                            const startDate = getFieldValue("startEffectiveDate");
                            if (startDate && value && moment(value).isSameOrBefore(moment(startDate), "date")) {
                                return Promise.reject(new Error(t("end-date-bigger-than-start-date")));
                            }
                            return Promise.resolve();
                        },
                    }),
                ]}
            >
                <DateInput placeholder={t("end-effective-date")} dateFormat="yyyy-MM-dd" />
            </Field>

            <Field
                name="pbjCode"
                label={t("PBJ-code")}
                rules={[
                    {
                        required: true,
                        message: t("required-pbj-code"),
                    },
                ]}
            >
                <ResourceSelect
                    labelPropName="description"
                    resourcePath="/pbj-code"
                    renderLabel={renderSettingsResourceLabel}
                    placeholder={t("PBJ")}
                    hasSearch
                    getSearchFilters={getSettingsResourceSearchFilters}
                />
            </Field>

            <div className="d-flex justify-content-end">
                <Button
                    type="button"
                    className="btn-round btn-icon shadow-none border btn btn-secondary btn-sm"
                    onClick={close}
                    disabled={loading}
                >
                    {t("cancel")}
                </Button>
                <Button
                    type="submit"
                    className="btn-round btn-icon shadow-none border px-3 btn btn-dark btn-sm"
                    loading={loading}
                >
                    {t("save")}
                </Button>
            </div>
        </Form>
    );
}

export default PBJForm;